import invariant from 'tiny-invariant'

const RAW_STUDIO_APP_URL = process.env.VITE_STUDIO_URL
invariant(RAW_STUDIO_APP_URL !== undefined, 'VITE_STUDIO_URL is required')
const STUDIO_APP_URL = RAW_STUDIO_APP_URL.trim().replace(/\/+$/, '')
invariant(STUDIO_APP_URL.length > 0, 'VITE_STUDIO_URL must not be empty')

/** Public Studio web origin from `VITE_STUDIO_URL` (inlined at build time in Vite/Next hosts). */
export function getStudioAppUrl(): string {
  return STUDIO_APP_URL
}

/** Absolute URL for a path on the Studio app origin. */
export function studioAppUrl(path = '/'): string {
  const origin = getStudioAppUrl()

  if (path === '/' || path === '') {
    return `${origin}/`
  }

  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${origin}${suffix}`
}
